"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBus = void 0;
class EventBus {
    constructor() {
        this.eventMap = new Map();
    }
    /**
     * @returns method to unsubscribe the subscription
     */
    subscribe(name, eventHandler) {
        if (!this.eventMap.has(name)) {
            this.eventMap.set(name, []);
        }
        this.eventMap.get(name).push(eventHandler);
        return () => this.unsubscribe(name, eventHandler);
    }
    unsubscribe(name, eventHandler) {
        if (this.eventMap.has(name)) {
            const eventHandlers = this.eventMap.get(name).filter(handler => handler !== eventHandler);
            this.eventMap.set(name, eventHandlers);
        }
    }
    publish(name, data) {
        if (this.eventMap.has(name)) {
            this.eventMap.get(name).forEach(eventHandler => {
                // push to task queue
                Promise.resolve().then(() => eventHandler(data));
            });
        }
    }
}
exports.EventBus = EventBus;
